import React, { useEffect } from 'react'
import './AboutUs.scss'

import arrow from '../../assets/Pictures/arrowAboutus.svg'

import { Link } from 'react-router-dom'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function AboutUs() {
  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  return (
    <div className='aboutUsPart'>
      <div className="container">
        <div className="row">
          <div className="aboutUs_contents" data-aos='fade-left'>
            <div className="aboutUs_content">
              <h1 className="ourProducts_contents_title">
                GLOBAL ENERGY INVESTMENT
              </h1>
              <h3 className="ourProducts_contents_subtitle">
                We are Engineering, Consultant and International Trading companies that operate in the sector of Steel Industrial, Construction 
                . Our companies activity mainly in Turkey and Oman. Vigor Global Energy company 
                “VGE” located in Istanbul, Turkey and Global Energy Investment company “GEI” located in Muscat, Oman.
                <br />
                <br />
                Our companies in Steel sector is official representative of the Kavir Steel Complex (one of the largest producers of steel products
                in the Middle East) in Turkey,Oman and African countries. we work close cooperation with the leading manufacturing and
                construction companies in Turkey, Oman and another countries for export high-quality products of Iron and Steel such as wire rod,
                steel ingot and steel rebar with special grade and European certificates to several factories used as raw material.
                <br />
                <img src={arrow} alt="arrow" /> <Link to='/corperate'>more</Link>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="aboutUsImage" data-aos='fade-right'>
      </div>
    </div>
  )
}
